// Global packages or components
import { useLoaderData } from '@remix-run/react'
import { resolveBlocks } from '~/.server'
import { getHome } from '~/sanity'
import { getMeta, getSchema, Schema } from '~/utils'
import { Blocks } from '~/components'
import { usePageInfo } from '~/hooks'

// Types
import type {
  MetaFunction,
  LoaderFunction,
  LoaderFunctionArgs,
} from '@remix-run/node'

// Route loader
export const loader: LoaderFunction = async ({
  request,
}: LoaderFunctionArgs) => {
  const env = process.env

  // Sanity fetch
  const data = await getHome({
    dataset: env?.ENVIRONMENT,
    projectId: env?.SANITY_PROJECT,
  })

  // Page not found
  if (!data) {
    throw new Response('Not Found', {
      status: 404,
    })
  }

  // Server renders the product carousels
  const { blocks } = await resolveBlocks({
    blocks: data?.flexibleContent,
    request,
  })

  // Return data
  return Response.json({
    seo: data?.seo,
    blocks,
    uspBlock: data?.showUSP,
  })
}

// Route meta
export const meta: MetaFunction = ({ matches, data }) => {
  return getMeta({
    matches,
    data,
  })
}

// Route view
export default function Index() {
  const { blocks, seo } = useLoaderData<typeof loader>()

  usePageInfo({
    pageType: 'Home',
  })

  const jsonLd = getSchema({
    type: 'page',
    page: seo,
  })

  return (
    <main>
      <Schema data={jsonLd} />
      <Blocks blocks={blocks} />
    </main>
  )
}
